module.exports = __webpack_public_path__ + "static/media/walk_disabled_person.e2ebec5a.svg";